import { render, staticRenderFns } from "./ArchiveTabLeaves.vue?vue&type=template&id=71d8e1be"
import script from "./ArchiveTabLeaves.vue?vue&type=script&lang=js"
export * from "./ArchiveTabLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports